import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronUp = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "14x14 / Directional / ic-chevron-down",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector 2 (Stroke)",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.6465 9.18588L11.2323 10.6001L6.93938 6.3072L2.64648 10.6001L1.23227 9.18588L6.93938 3.47878L12.6465 9.18588Z",
			fill: "#828599"
		})
	})]
});
const ForwardRef = forwardRef(SvgChevronUp);
export default ForwardRef;
